export const GRAPHQL_URL = `${window.ENV.HTTP_URL}/calibration/graphql`
// export const GRAPHQL_URL = 'http://localhost:4000/graphql'
